

const config = {
    phone: '+1 (855) 702-8121',
    supportEmail: 'support@paperclouds.co',
    companyName: 'Paper Clouds'
}
export default config